import { render, staticRenderFns } from "./ordersDialog.vue?vue&type=template&id=63483466&scoped=true"
import script from "./ordersDialog.vue?vue&type=script&lang=js"
export * from "./ordersDialog.vue?vue&type=script&lang=js"
import style0 from "./ordersDialog.vue?vue&type=style&index=0&id=63483466&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63483466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63483466')) {
      api.createRecord('63483466', component.options)
    } else {
      api.reload('63483466', component.options)
    }
    module.hot.accept("./ordersDialog.vue?vue&type=template&id=63483466&scoped=true", function () {
      api.rerender('63483466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/ordersDialog.vue"
export default component.exports